<app-page-shell>
    <app-page-hero
        eyebrow="Vendor Controls"
        title="Vendor Statement Reconciliation"
        subtitle="First-slice shell for imported vendor statements, matched bills/credits, differences, and exception workflow. Backend import/matching endpoints are pending.">
        <div actions>
            <p-button label="Import Statement" icon="pi pi-upload" [disabled]="true" title="Backend import endpoint pending"></p-button>
        </div>
    </app-page-hero>

    <app-page-metric-strip [metrics]="metrics"></app-page-metric-strip>

    <p-tabs [value]="activeTab" (valueChange)="setActiveTab($event)">
        <p-tablist>
            <p-tab value="list"><app-accounting-tab-label icon="pi pi-list" label="Statements"></app-accounting-tab-label></p-tab>
            <p-tab value="detail"><app-accounting-tab-label icon="pi pi-info-circle" label="Detail"></app-accounting-tab-label></p-tab>
            <p-tab value="activity"><app-accounting-tab-label icon="pi pi-history" label="Activity"></app-accounting-tab-label></p-tab>
        </p-tablist>
        <p-tabpanels>
            <p-tabpanel value="list">
                <app-page-data-panel title="Statements" subtitle="Imported vendor statement records will appear here." [resultText]="filteredRows.length + ' statements'">
                    <div actions>
                        <input pInputText [(ngModel)]="vendorFilter" placeholder="Vendor filter">
                    </div>
                    <p-table [value]="filteredRows" responsiveLayout="scroll">
                        <ng-template pTemplate="header">
                            <tr><th>Statement</th><th>Vendor</th><th>Date</th><th class="numeric">Statement</th><th class="numeric">Matched</th><th class="numeric">Difference</th><th>Status</th><th></th></tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-row>
                            <tr>
                                <td>{{ row.statementNumber }}</td>
                                <td>{{ row.vendorName }}</td>
                                <td>{{ row.statementDate | date:'yyyy-MM-dd' }}</td>
                                <td class="numeric">{{ money(row.statementAmount) }}</td>
                                <td class="numeric">{{ money(row.matchedAmount) }}</td>
                                <td class="numeric">{{ money(row.differenceAmount) }}</td>
                                <td><p-tag [value]="row.status" [severity]="severity(row.status)"></p-tag></td>
                                <td><p-button label="Open" icon="pi pi-external-link" size="small" [outlined]="true" (click)="select(row)"></p-button></td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr><td colspan="8">No vendor statements have been imported yet.</td></tr>
                        </ng-template>
                    </p-table>
                </app-page-data-panel>
            </p-tabpanel>
            <p-tabpanel value="detail">
                <app-page-data-panel title="Statement Detail" subtitle="Matched bills, credits, and differences will be shown after the statement import API is added.">
                    <div class="placeholder">
                        <i class="pi pi-file-check"></i>
                        <strong>{{ selected?.statementNumber || 'No statement selected' }}</strong>
                        <span>Vendor statement detail is intentionally a shell in this Phase 7 slice.</span>
                    </div>
                </app-page-data-panel>
            </p-tabpanel>
            <p-tabpanel value="activity">
                <app-page-data-panel title="Activity">
                    <div class="placeholder">
                        <i class="pi pi-history"></i>
                        <strong>Audit-ready timeline placeholder</strong>
                        <span>Import, match, difference approval, and reconciliation audit events will bind here when backend support is added.</span>
                    </div>
                </app-page-data-panel>
            </p-tabpanel>
        </p-tabpanels>
    </p-tabs>
</app-page-shell>
